"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QR_BRAND_TYPE = exports.ProductCodes = exports.ProductSubscriptionDurations = exports.PlanSubscriptionCategories = exports.ProductTypes = void 0;
var ProductTypes;
(function (ProductTypes) {
    ProductTypes["ala_carte"] = "ala_carte";
    ProductTypes["more_scans"] = "more_scans";
    ProductTypes["plan_subscription"] = "plan_subscription";
})(ProductTypes = exports.ProductTypes || (exports.ProductTypes = {}));
var PlanSubscriptionCategories;
(function (PlanSubscriptionCategories) {
    PlanSubscriptionCategories["pro"] = "pro";
    PlanSubscriptionCategories["free"] = "free";
    PlanSubscriptionCategories["lite"] = "lite";
    PlanSubscriptionCategories["basic"] = "basic";
    PlanSubscriptionCategories["enterprise"] = "enterprise";
})(PlanSubscriptionCategories = exports.PlanSubscriptionCategories || (exports.PlanSubscriptionCategories = {}));
var ProductSubscriptionDurations;
(function (ProductSubscriptionDurations) {
    ProductSubscriptionDurations["DAY"] = "day";
    ProductSubscriptionDurations["YEAR"] = "year";
    ProductSubscriptionDurations["WEEK"] = "week";
    ProductSubscriptionDurations["MONTH"] = "month";
})(ProductSubscriptionDurations = exports.ProductSubscriptionDurations || (exports.ProductSubscriptionDurations = {}));
var ProductCodes;
(function (ProductCodes) {
    ProductCodes["QR_SCANS"] = "QRC";
    ProductCodes["QR_PLAN_PRO"] = "QRP-PRO";
    ProductCodes["QR_PLAN_FREE"] = "QRP-FREE";
    ProductCodes["QR_PLAN_LITE"] = "QRP-LITE";
    ProductCodes["QR_PLAN_BASIC"] = "QRP-BASIC";
    ProductCodes["QR_PLAN_CUSTOM"] = "QRP-CUSTOM";
    ProductCodes["QR_PLAN_ENTERPRICE"] = "QRP-ENTERPRICE";
    ProductCodes["QR_ALACARTE_CUSTOM"] = "QR-ALACARTE-CUSTOM";
    ProductCodes["QR_ALACARTE_NO_BRAND"] = "QR-ALACARTE-NO-BRAND";
    ProductCodes["QR_ALACARTE_BRANDQRCODES"] = "QR-ALACARTE-BRANDQRCODES";
})(ProductCodes = exports.ProductCodes || (exports.ProductCodes = {}));
var QR_BRAND_TYPE;
(function (QR_BRAND_TYPE) {
    // CUSTOM = "custom",
    QR_BRAND_TYPE["NO_BRAND"] = "no-brand";
    QR_BRAND_TYPE["BRANDQRCODES"] = "brandqrcodes";
})(QR_BRAND_TYPE = exports.QR_BRAND_TYPE || (exports.QR_BRAND_TYPE = {}));
